import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import {
  Container,
  Header,
  ContentContainer,
  Content,
  Buttons,
} from '../CustomizableDialogView';
import PillButton from '../../shared/button/PillButton';
import SkyButton from '../../shared/button/SkyButton';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import useOnMount from '../../../hooks/useOnMount';

import { DISMISS } from '../../../constants/localizations/shared';
import { themeConstants, errorValues } from './constants';

import css from './messageOfTheDayView.module.scss';

export default function MessageOfTheDayView({
  categoryId,
  themeType,
  handleSubmit,
  handleClose,
  handleError,
  isFullScreen,
}) {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const { titleKey, subtitleKey, callToActionKey, backgroundImageUrl } =
    themeConstants[themeType] || {};
  const headerStyles = { backgroundImage: `url(${backgroundImageUrl})` };

  useOnMount(() => {
    if (!themeConstants[themeType]) {
      handleError(`${errorValues.unsupportedCategoryId}-${categoryId}`);
    }
  });

  if (!themeConstants[themeType]) {
    return null;
  }

  return (
    <Container
      className={classNames(css.container, { fullScreen: isFullScreen })}
    >
      <Header
        className={classNames(css.header, themeType)}
        overlayClassName={css.headerOverlay}
        style={headerStyles}
      />
      <ContentContainer className={css.contentContainer}>
        <Content className={css.content}>
          <div className={css.title}>{getLocalizedText(titleKey)}</div>
          <div className={css.subtitle}>{getLocalizedText(subtitleKey)}</div>
        </Content>
        <Buttons className={css.buttons}>
          <SkyButton
            id="messageOfTheDaySubmitButton"
            onClick={handleSubmit}
            label={getLocalizedText(callToActionKey)}
            className={css.submitButton}
          />
          <PillButton
            id="messageOfTheDayDismissButton"
            onClick={handleClose}
            label={getLocalizedText(DISMISS)}
          />
        </Buttons>
      </ContentContainer>
    </Container>
  );
}

MessageOfTheDayView.propTypes = {
  categoryId: PropTypes.string.isRequired,
  themeType: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
};
